import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { ModalController } from '@ionic/angular';
import { ToastService } from 'src/app/services/toast.service';
import { TranslateService } from '@ngx-translate/core';
import { AppConstants } from 'src/app/utilities/constant';

@Component({
  selector: 'app-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.scss'],
})
export class DynamicFormComponent implements OnInit {

  @Output() onCancelClick = new EventEmitter<string>();
  @Input() form: FormGroup;
  @Input() fieldsData: any = [];
  @Input() title: any;
  @Input() model: any;
  @Input() resetOnSubmit: boolean = true;
  @Output() formData: EventEmitter<any> = new EventEmitter<any>();
  public fields: FormlyFieldConfig[];

  constructor(
    public modalController: ModalController,
    private readonly toastService: ToastService,
    private readonly translate: TranslateService
  ) {
  }

  ngOnInit() {
    this.fields = this.fieldsData;
  }

  /**
   * To emit the event on submitting the form
   */
  public onSubmit(formDirective) {
    if (this.form.valid) {
      this.formData.emit(this.form.value);
      return;
    }

    this.form.markAllAsTouched();

    const whitespaceOnlyControl = this.findWhitespaceOnlyControl(this.form);
    if (whitespaceOnlyControl) {
      this.toastService.presentToast(
        this.translate.instant('only_spaces_are_not_allowed'),
        4000,
        AppConstants.ERROR_SNACKBAR,
        'top'
      );
    }
  }

  private findWhitespaceOnlyControl(formGroup: FormGroup): boolean {
    for (const controlName in formGroup.controls) {
      if (!Object.prototype.hasOwnProperty.call(formGroup.controls, controlName)) {
        continue;
      }

      const control = formGroup.controls[controlName];
      const value = control.value;
      const isWhitespaceOnlyValue = typeof value === 'string' && value.trim().length === 0 && value.length > 0;

      if (control.errors?.whitespaceOnly || control.errors?.whitespace || (isWhitespaceOnlyValue && control.errors?.required)) {
        return true;
      }

      if ((control as any).controls) {
        const childGroup = control as FormGroup;
        if (this.findWhitespaceOnlyControl(childGroup)) {
          return true;
        }
      }
    }

    return false;
  }

  /**
   * Determines whether cancel on
   */
  public onCancel(formDirective) {
    this.onCancelClick.emit();
    this.resetForm(formDirective);
  }

  /**
   * Resets form
   *
   * @param formDirective
   */
  private resetForm(formDirective) {
    this.form.reset();
    formDirective.resetForm();
  }
}
